module.exports = __webpack_public_path__ + "static/img/lb_img_6.bcbdbbff.png";